/* eslint-disable no-unused-vars */
/* eslint-disable import/no-cycle */
import React from "react";
import { useTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format, isValid } from "date-fns";
import dayjs from "dayjs";
import PTMInput from "../PTMInput";
import PasswordCheckHandler from "./PasswordCheckHandler";

export default function InputSelector(props) {
    const {
        column,
        errors,
        isEdit,
        entry,
        lockedValue,
        lockedProp,
        getValues,
        setValue,
        setError,
        dynamicPropSetter,
        dynamicPropGetter,
    } = props;

    const renderPropHandler = () => {
        let value = "";
        // manage nested props
        const dataNameSplit = column.dataName?.split(".");
        if (dataNameSplit?.length > 1) {
            const parentProp = dataNameSplit[0];
            const childProp = dataNameSplit[1];
            if (entry[parentProp]) {
                value = entry[parentProp][childProp];
            }
        } else {
            value = entry[column.dataName];
        }

        if (["multiselect"].includes(column.type)) {
            if (column.fallbackDataName) {
                value = entry[column.fallbackDataName];
            } else {
                const valueArr = [];
                if (entry[column.dataName] && entry[column.dataName].length > 0) {
                    entry[column.dataName].forEach((id) => {
                        const option = column?.options?.find((item) => item[column.optionsKey] === id);
                        if (option) {
                            valueArr.push(option[column.optionsName]);
                        }
                    });
                }

                value = valueArr.join(", ");
            }
        } else if (["select", "autocomplete", "autocompleteAsync"].includes(column.type)) {
            if (column.fallbackDataName) {
                value = entry[column.fallbackDataName];
            } else {
                const option = column?.options?.find((item) => item[column.optionsKey] === value);
                if (option) {
                    value = option[column.optionsName];
                }
            }
        } else if (column.type === "checkbox") {
            return (<FontAwesomeIcon icon={(value === 1 || value === true || value === "1") ? "square-check" : "square"} />);
        } else if (column.type === "icon") {
            return (<FontAwesomeIcon icon={value} />);
        }

        return value;
    };

    const formatString = (text) => {
        if (column?.dateFormat && text) {
            if (!isValid(new Date(text))) return "Kein Datum ausgewählt";
            return format(new Date(text), column?.dateFormat);
        }

        if (column?.allowHTML && text) {
            return (<div dangerouslySetInnerHTML={{ __html: text }} />);
        }

        if (column?.removeHTML && text) {
            return text?.replace(/<[^>]*>?/gm, "");
        }

        return text;
    };

    const dynamicOptionsHandler = () => {
        const options = column.dynamicOptions;

        if (!options) {
            return column.options;
        }

        if (options?.enabled && options?.getFormValues) {
            return getValues(column.dynamicOptions.dataName);
        }
        if (options?.enabled && options?.addFields) {
            const check = column.options.find(((option) => option.contact_id === entry.contact_id));

            // used for example in help desk zugänge, to add new elements "on the fly" to the list
            return !check ? [{
                contact_id: entry.contact_id,
                emailAddresses: entry.emailAddresses,
                first_addon: entry.first_addon || "",
                show_name: entry.show_name,
            }, ...column.options] : column.options;
        }
    };

    const theme = useTheme();

    const muiTheme = useTheme();
    const inputs = {
        text: (isEdit
            ? (
                <PTMInput
                    fullWidth
                    disabled={column.disabled}
                    name={column.dataName}
                    placeholder={column.placeholder || (!column.disabled && column.name)}
                    required={!column.disabled && column.required}
                    /* eslint-disable-next-line no-unused-expressions */
                    onBlur={async (e) => { column?.setValueTrigger?.eventListener === "onBlur" ? await column.onBlur(e) && setError(column?.setValueTrigger?.targetName) : column?.onBlur && column.onBlur(); }}
                    type={column.textType}
                    dateParseTemplate={column.dateParseTemplate}
                    multiline={column.textMultiline}
                    rows={column.textRows}
                    filterDisabled={column.filterDisabled}
                    filterData={column.filterDisabled}
                    step={column.step}
                    inputProps={column.inputProps}
                    allowGeneratePassword={column.allowGeneratePassword}
                    customGeneratePasswordFunction={column.customGeneratePasswordFunction}
                    autoFocus={column.autoFocus}
                    // validate={column.validate}
                    // sx={{ border: errors.salutation && "1px solid green" }}
                />
            )
            : formatString(renderPropHandler())
        ),
        colorPicker:

            column.preview ? (
                <PTMInput
                    fullWidth
                    disabled
                    value={!column.preview.hideText ? "Der Text wird wie folgt angezeigt" : ""}
                    //                 if (column.preview) {
                    //     console.log(column);
                    //     console.log(getValues(column.preview?.patternField || "pattern"));
                    //     if (column.preview?.patterns && column.preview?.patternField) {
                    //         const pattern = column.preview?.patterns.find((item) => getValues(column.preview?.patternField || "pattern") === item?.name);
                    //         console.log(pattern);
                    //     }
                    // }
                    sx={{
                        backgroundColor: getValues(column.preview?.bgColorField || "bg_color"),
                        "& .MuiOutlinedInput-input": { color: `${getValues(column.preview?.bgColorField || "bg_color")} !important` },
                        ...column.preview?.patterns && column.preview?.patternField
                            ? (column.preview?.patterns.find((item) => getValues(column.preview?.patternField || "pattern") === item?.name)?.css(getValues(column.preview?.patternColorField || "pattern_color"), getValues(column.preview?.bgColorField || "bg_color")) || {})
                            : {},
                    }}
                />
            ) : (isEdit ? (
                <PTMInput
                    fullWidth
                    disabled={column.disabled}
                    name={column.dataName}
                    placeholder={!column.disabled && column.name}
                    required={!column.disabled && column.required}
                    type="color"
                    /* eslint-disable-next-line no-unused-expressions */
                    onChange={(e) => { column?.setValueTrigger?.enabled ? setValue(column?.setValueTrigger?.targetName, column.onChange(e)) : column.onChange && column.onChange(e); }}
                    sx={{ "& fieldset": { border: "none" } }}
                />

            ) : (
                <PTMInput
                    fullWidth
                    disabled
                    name={column.dataName}
                    placeholder={!column.disabled && column.name}
                    required={!column.disabled && column.required}
                    type="color"
                    sx={
                        {
                            "& fieldset": { border: "none" }, "& .Mui-disabled": { backgroundColor: "#f9f9f9 !important" },
                        }
                    }
                />
            )
            ),
        autocompleteAsync: (isEdit ? (
            <PTMInput
                disabled={!isEdit}
                fullWidth
                name={column.dataName}
                required={column.required}
                type="autocomplete-async"
                disablePortal
                optionsValueType="key"
                optionsKey="id"
                labelFormat={(row) => `${row.show_name} ${row.first_addon ? "-" : ""} ${row.first_addon ? row.first_addon : ""}`}
                optionsFormat={(row) => (
                    <div>
                        {row.show_name}
                        {row.first_addon && (
                            <>
                                <br />
                                <div style={{ color: muiTheme.palette.text.secondary }}>
                                    {row.first_addon}
                                </div>
                            </>
                        )}
                    </div>
                )}
                getOptions={async (inputValue) => {
                    const { data } = await column.getOptionsApi(inputValue);
                    return data.data;
                }}
                getSelectedOption={async (payload) => {
                    const { data: { data: contactsData } } = await column.getSelectOptionApi(payload);
                    return contactsData[0] || null;
                }}
                getOptionLabel={(option) => `${option.name} ${option.first_addon ? `- ${option.first_addon}` : ""}`}
                onChange={(e, value) => {
                    if (column.onChange) {
                        column.onChange(e, value);
                    }
                }}
                autoFocus={column.autoFocus}
            />
        )
            : formatString(renderPropHandler())
        ),
        select: (isEdit
            ? (
                <PTMInput
                    fullWidth
                    type="select"
                    disabled={column.disabled}
                    /* eslint-disable-next-line no-unused-expressions */
                    onChange={(e) => { column?.setValueTrigger?.enabled ? setValue(column?.setValueTrigger?.targetName, column.onChange(e)) : column.onChange && column.onChange(e); }}
                    name={column.dataName}
                    // placeholder={!column.disabled && column.name}
                    required={!column.disabled && column.required}
                    options={dynamicOptionsHandler()}
                    // options={column.dynamicOptions?.enabled ? getValues(column.dynamicOptions.dataName) : column.options}
                    optionsValueType="key"
                    optionsKey={column.optionsKey}
                    optionsName={column.optionsName}
                    optionsFormat={column.optionsFormat}
                    filterOptions={(row) => {
                        if (column.filterOptions) return column.filterOptions(row, getValues);
                        return true;
                    }}
                    // sx={{ border: errors.salutation && "2px solid red" }}
                    autoFocus={column.autoFocus}
                />
            )
            : formatString(renderPropHandler())
        ),
        multiselect: (isEdit
            ? (
                <PTMInput
                    fullWidth
                    type="multiselect"
                    disabled={column.disabled}
                    /* eslint-disable-next-line no-unused-expressions */
                    onChange={(e) => { column?.setValueTrigger?.enabled ? setValue(column?.setValueTrigger?.targetName, column.onChange(e)) : column.onChange && column.onChange(e); }}
                    name={column.dataName}
                    required={!column.disabled && column.required}
                    options={dynamicOptionsHandler()}
                    optionsKey={column.optionsKey}
                    optionsName={column.optionsName}
                    optionsFormat={column.optionsFormat}
                    autoFocus={column.autoFocus}
                />
            )
            : formatString(renderPropHandler())
        ),

        autocomplete: (isEdit
            ? (
                <PTMInput
                    fullWidth
                    type="autocomplete"
                    disableClearable
                    disabled={column.disabled}
                    /* eslint-disable-next-line no-unused-expressions */
                    onChange={(e) => { column?.setValueTrigger?.enabled ? setValue(column?.setValueTrigger?.targetName, column.onChange(e)) : column.onChange && column.onChange(e); }}
                    name={column.dataName}
                    // placeholder={!column.disabled && column.name}
                    required={!column.disabled && column.required}
                    // options={column.dynamicOptions?.enabled ? getValues(column.dynamicOptions.dataName) : column.options}
                    options={dynamicOptionsHandler()}
                    optionsValueType="key"
                    optionsKey={column.optionsKey}
                    optionsName={column.optionsName}
                    // sx={{ border: errors.salutation && "2px solid red" }}
                    autoFocus={column.autoFocus}
                />
            )
            : formatString(renderPropHandler())
        ),

        checkbox: (isEdit
            ? (
                <PTMInput
                    fullWidth
                    disabled={column.disabled || (column.conditionalDisabled && column.conditionalDisabled(getValues()))}
                    name={column.dataName}
                    placeholder={!column.disabled && column.name}
                    required={!column.disabled && column.required}
                    type="checkbox"
                    autoFocus={column.autoFocus}
                />
            )
            : formatString(renderPropHandler())
        ),
        icon: (isEdit
            ? (
                <PTMInput
                    disabled={column.disabled}
                    name={column.dataName}
                    required={!column.disabled && column.required}
                    type="icon"
                />
            )
            : formatString(renderPropHandler())
        ),
        dot: (
            <FontAwesomeIcon
                icon={entry[lockedProp] === lockedValue ? "lock" : "circle"}
                color={entry[lockedProp] === lockedValue ? "black" : entry[column.dataName] ? theme.palette.success.main : theme.palette.error.main}
            />
        ),
        justIcon: (
            <FontAwesomeIcon
                icon={column.getIcon && column.getIcon(entry, isEdit)}
                color={column.getIconColor && column.getIconColor(entry, isEdit, theme)}
            />
        ),
        passwordCheck: (
            <PasswordCheckHandler
                login={entry}
                setError={setError}
                name={column.dataName}
                isNew={entry?.is_new}
            />
        ),
        datetimepicker: (
            isEdit
                ? (
                    <PTMInput
                        name={column.dataName}
                        type="datetimepicker"
                        required={!column.disabled && column.required}
                        validate={column.validate}
                        disabled={column.disabled}
                        onChange={
                            (e) => {
                                /* eslint-disable-next-line no-lone-blocks */
                                {
                                    let timeValue;

                                    if (column.setValueTrigger?.targetName === "work_end") {
                                        timeValue = dayjs(column.onChange(e)).add(15, "minute");
                                        /* eslint-disable-next-line no-unused-expressions */
                                        column.setValueTrigger?.enabled && setValue(column.setValueTrigger.targetName, timeValue);
                                    }
                                    // else {
                                    //     // timeValue = dayjs(column.onChange(e)).subtract(15, "minute");
                                    //     timeValue = column.onChange(e);
                                    // }
                                    /* eslint-disable-next-line no-unused-expressions */
                                    column.setterProp ? dynamicPropSetter(column.setterProp, column.onChange(e)) : column.onChange(e);
                                }
                            }

                        }
                        minDateTime={column.getterProp === "startDate" ? dynamicPropGetter(column.getterProp) : null}
                        maxDateTime={column.getterProp === "endDate" ? dynamicPropGetter(column.getterProp) : null}
                        autoFocus={column.autoFocus}
                    />
                ) : formatString(renderPropHandler())
        ),
        datepicker: (
            isEdit
                ? (
                    <PTMInput
                        name={column.dataName}
                        type="datepicker"
                        required={!column.disabled && column.required}
                        validate={column.validate}
                        disabled={column.disabled}
                        minDateTime={column.getterProp === "startDate" ? dynamicPropGetter(column.getterProp) : null}
                        maxDateTime={column.getterProp === "endDate" ? dynamicPropGetter(column.getterProp) : null}
                        autoFocus={column.autoFocus}
                        sx={{
                            "& .MuiStack-root": { overflow: "hidden", paddingTop: "1px", "& *": { height: "24px" } },
                        }}
                    />
                ) : formatString(renderPropHandler())
        ),

    };
    return inputs[column.type] || inputs.text || "";
}
